class ProductImageGalleries extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.selectors = {}
    this.currentVariant = ''
    this.hasFetched = false
    this.init()
  }

  connectedCallback () {
    super.connectedCallback()
  }

  init () {
    this.galleries = this.els.gallery

    const params = new URLSearchParams(window.location.search)

    if (!params.has('variant')) {
      this.loading(false)
    }
  }

  showGalleries (elements) {
    elements.forEach(el => {
      el.removeAttribute('aria-hidden')
    })
  }

  hideGalleries (elements) {
    elements.forEach(el => {
      el.setAttribute('aria-hidden', 'true')
    })
  }

  update () {
    this.hideGalleries(this.allGalleries)

    if (this.variantGalleries) {
      this.showGalleries(this.variantGalleries)
    } else {
      this.showGalleries(this.productGalleries)
    }
  }

  get allGalleries () {
    return this.galleries.elements.map(el => el)
  }

  get productGalleries () {
    const galleries = this.galleries.elements.filter(
      el => el.dataset.galleryType === 'product',
    )
    return galleries.length > 0 ? galleries : null
  }

  get variantGalleries () {
    if (!this.currentVariant) return null

    const galleries = this.galleries.elements.filter(
      el => el.dataset.variantId === this.currentVariant,
    )
    return galleries.length > 0 ? galleries : null
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document,
      'variantChange',
      this.handleVariantChange.bind(this),
    )
  }

  get url () {
    return `${window.location.origin}/${window.location.pathname}`
  }

  async fetchVariantGalleries () {
    const html = await window.BAO.sectionRenderer.fetchSingle(
      'section-variant-gallery',
      this.url,
    )

    this.els.variants.element.innerHTML = html
  }

  loading (state) {
    if (state) {
      this.els.container.element.setAttribute('data-loading', true)
      return
    }

    this.els.container.element.removeAttribute('data-loading')
  }

  async handleVariantChange (evt) {
    if (!this.hasFetched) {
      this.loading(true)
      await this.fetchVariantGalleries()
      this.hasFetched = true
      this.init()
      this.loading(false)
    }

    const { hasVariant = false, variant: { id = '' } = {} } = evt.detail

    this.currentVariant = hasVariant ? String(id) : null

    this.update()
  }
}

if (!customElements.get('')) {
  customElements.define('product-image-galleries', ProductImageGalleries)
}
